import React from 'react';
import Super_admin_web_protal from '../../../layout/Super_admin_web_portal';
import RunningCaseDepositsPage from '../../../components/RunningCaseDepositsPage';

const SuperRunningCaseDeposits = () => (
  <RunningCaseDepositsPage
    Layout={Super_admin_web_protal}
    backPath="/super_admin/running-cases"
  />
);

export default SuperRunningCaseDeposits;
